import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=d1883ce8&"
import script from "./FormSetting.vue?vue&type=script&lang=js&"
export * from "./FormSetting.vue?vue&type=script&lang=js&"
import style0 from "./FormSetting.vue?vue&type=style&index=0&id=d1883ce8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports